import { Container, Grid, Tooltip, Typography } from '@material-ui/core';
import React, { useState, useRef, useEffect } from 'react';
import EntryRow from './EntryRow';
import { timecardWorkdayStyles } from './style';
import WorkdayHoursForm from './WorkdayHoursForm';
import { useCallback } from 'react';
import { debounce } from '../../redux/hooks/use-debounce';
import { QueryBuilder } from '@material-ui/icons';
import dateUtil from '../../util/dateUtil';
import Visible from '../../components/Visible';
import { useSelector } from 'react-redux';

const Workday = ({
  workday,
  entries,
  activeDay,
  setActiveDay,
  isPriorWorkday,
  isAfterWorkday,
  disabled,
}) => {
  const ref = useRef(null);
  const classes = timecardWorkdayStyles();
  const user = useSelector((state) => state.user);
  //Used to keep jumping scroll issue when scroll sets activeDay
  //const [ignoreActiveDayUpdate, setIgnoreActiveDayUpdate] = useState(false);
  //Event handler that will update active day as scrolling occurs

  // const onScroll = () => {
  //   if (ref.current) {
  //     updateActiveDay(ref);
  //   }
  // };

  const getWarning = (localWorkday) => {
    if (!localWorkday) {
      localWorkday = workday;
    }
    if (!localWorkday) return { level: 'none', message: '' };
    else if (!dateUtil.isBeforeToday(localWorkday.workDate))
      return { level: 'none', message: '' };
    else if (user.payType == 'SALARY') return { level: 'none', message: '' };
    else if (
      dateUtil.isBeforeToday(localWorkday.workDate) &&
      !dateUtil.isWeekend(localWorkday.workDate) &&
      localWorkday.workHours == 0 &&
      localWorkday.vacationHours == 0 &&
      localWorkday.holidayHours == 0 &&
      localWorkday.sickHours == 0
    )
      return { level: 'error', message: 'Hours need to be set for this work day' };
    else if (localWorkday.workHours < localWorkday.bonusHours)
      return {
        level: 'error',
        message: "Bonus hours can't exceed work hours",
      };
    else if (
      !dateUtil.isWeekend(localWorkday.workDate) &&
      localWorkday.workHours +
      localWorkday.vacationHours +
      localWorkday.sickHours +
      localWorkday.holidayHours <
      8
    )
      return { level: 'warning', message: 'Warning: total hours less than 8' };
    else return { level: 'none', message: '' };
  };

  const defaultView = () => {
    if (isPriorWorkday) return 'PRIOR';
    else if (isAfterWorkday) return 'AFTER';
    else if (
      dateUtil.isBeforeToday(workday.workDate) &&
      dateUtil.isWeekend(workday.workDate) &&
      !workday.workHours &&
      !workday.bonusHours &&
      !workday.billedHours &&
      entries.length == 0
    )
      return 'BLANK';
    else if (
      dateUtil.isAfterToday(workday.workDate) &&
      !workday.workHours &&
      !workday.bonusHours &&
      !workday.billedHours &&
      entries.length == 0
    )
      return 'BLANK';
    else if (
      getWarning().level == 'none' &&
      dateUtil.isBeforeToday(workday.workDate) &&
      (dateUtil.isWeekend(workday.workDate) ||
        workday.workHours != 0 ||
        workday.vacationHours != 0 ||
        workday.sickHours != 0 ||
        workday.holidayHours != 0)
    )
      return 'SMALL';
    else if (user.payType == 'SALARY') return 'SMALL';
    else return 'FULL';
  };

  useEffect(() => {
    const newView = defaultView();
    if ((view == 'SMALL' || view == 'BLANK') && newView == 'FULL') setView('FULL');
    if (view == 'BLANK' && newView == 'SMALL') setView('SMALL');
  }, [workday]);
  useEffect(() => {
    setView(defaultView());
  }, [workday.workDate]);

  const [view, setView] = useState(defaultView());
  const updateActiveDay = useCallback(
    debounce((ref) => {
      //this doesn't work in mobile view so just ignore the error
      try {
        const top = ref.current.getBoundingClientRect().top;
        const bottom = ref.current.getBoundingClientRect().height + top;
        if (top <= 300 && bottom > 300 && activeDay != workday.workDate) {
          setIgnoreActiveDayUpdate(true);
          setActiveDay(workday.workDate);
        }
      } catch (e) { }
    }, 100),
    [activeDay]
  );
  //Register onScroll with component
  // useEffect(() => {
  //   window.addEventListener('scroll', onScroll);
  //   return () => window.removeEventListener('scroll', onScroll);
  // }, []);
  //perform scroll if activeDay was updated by button click or onload
  // useEffect(() => {
  //   let isScrolling = false;
  //   if (!ignoreActiveDayUpdate) {
  //     //Scroll to today if timecard contains today
  //     if (isPriorWorkday ? activeDay === PRIOR : activeDay === workday.workDate) {
  //       window.scrollTo({
  //         top: ref.current.offsetTop - 200,
  //         left: 0,
  //         behavior: 'smooth',
  //       });
  //       isScrolling = true;
  //     }
  //   } else setIgnoreActiveDayUpdate(false);
  // }, [activeDay]);

  const toggleSmallView = () => {
    if (view == 'FULL') setView('SMALL');
    else if (view == 'SMALL') setView('FULL');
  };
  const onHoursUpdate = (newWorkday) => {
    setWarning(getWarning(newWorkday));
  };

  const [warning, setWarning] = useState({ level: 'none', message: '' });

  useEffect(() => {
    setWarning(getWarning());
  }, [workday]);

  return (
    <div ref={ref}>
      {view == 'PRIOR' ? (
        <Container className={classes.headerContainerSmall}>
          <div style={{ margin: 'auto 0px' }}>
            <Typography>Prior Entries</Typography>
          </div>
        </Container>
      ) : view == 'AFTER' ? (
        <Container className={classes.headerContainerSmall}>
          <div style={{ margin: 'auto 0px' }}>
            <Typography>Entries AFTER this period - please review</Typography>
          </div>
        </Container>
      ) : view == 'SMALL' ? (
        <Container
          onClick={toggleSmallView}
          className={classes.headerContainerSmall}
          style={
            warning.level == 'error'
              ? { backgroundColor: 'lightcoral' }
              : warning.level == 'warning'
                ? { backgroundColor: 'lightyellow' }
                : {}
          }
        >
          <Grid container className={classes.headerContent}>
            <Grid item xs={11} className={classes.headerContent}>
              <Typography>
                {dateUtil.stringToDateFormat(workday.workDate, 'EEEE LLLL do')}
              </Typography>
            </Grid>
            <Grid item xs={1} style={{ textAlign: 'right', marginTop: 2 }}>
              <Tooltip
                title={warning?.message || 'Show/hide hours'}
                aria-label={warning?.message || 'Show/hide hours'}
              >
                <QueryBuilder
                  color="primary"
                  fontSize="small"
                  onClick={toggleSmallView}
                />
              </Tooltip>
            </Grid>
          </Grid>
        </Container>
      ) : view == 'FULL' ? (
        <>
          <Visible smUp>
            <Container
              className={classes.headerContainer}
              style={
                warning.level == 'error'
                  ? { backgroundColor: 'lightcoral' }
                  : warning.level == 'warning'
                    ? { backgroundColor: 'lightyellow' }
                    : {}
              }
            >
              <Grid container>
                <Grid item xs={11}>
                  <WorkdayHoursForm
                    workday={workday}
                    entries={entries}
                    disabled={disabled}
                    key={workday.workDate}
                    onUpdate={onHoursUpdate}
                  />
                </Grid>
                <Grid item xs={1} style={{ textAlign: 'right', alignSelf: 'center' }}>
                  <Tooltip
                    title={warning.message || 'Show/hide hours'}
                    aria-label={warning.message || 'Show/hide hours'}
                  >
                    <QueryBuilder
                      color="disabled"
                      fontSize="small"
                      onClick={toggleSmallView}
                    />
                  </Tooltip>
                </Grid>
              </Grid>
            </Container>
          </Visible>
          <Visible xsDown>
            <Container
              onClick={toggleSmallView}
              className={classes.headerContainerSmall}
              style={
                warning.level == 'error'
                  ? { backgroundColor: 'lightcoral' }
                  : warning.level == 'warning'
                    ? { backgroundColor: 'lightyellow' }
                    : {}
              }
            >
              <Grid container className={classes.headerContent}>
                <Grid item xs={11} className={classes.headerContent}>
                  <Typography>
                    {dateUtil.stringToDateFormat(workday.workDate, 'EEEE LLLL do')}
                  </Typography>
                </Grid>
                <Grid item xs={1} style={{ textAlign: 'right', marginTop: 2 }}>
                  <Tooltip
                    title={warning?.message || 'Show/hide hours'}
                    aria-label={warning?.message || 'Show/hide hours'}
                  >
                    <QueryBuilder
                      color="primary"
                      fontSize="small"
                      onClick={toggleSmallView}
                    />
                  </Tooltip>
                </Grid>
              </Grid>
            </Container>
          </Visible>
        </>
      ) : (
        ''
      )}
      {entries.length > 0 && (
        <Container style={{ paddingRight: 0, marginBottom: 6 }}>
          {entries.map((entry, index) => (
            <EntryRow key={index} entry={entry} disabled={disabled} />
          ))}
        </Container>
      )}
    </div>
  );
};

export default Workday;
